import { render } from "./Template.vue?vue&type=template&id=2cf325f5&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2cf325f5"

export default script